<template>
    <tr>
        <td>
            <button class="button is-primary" :disabled="isLocked" @click="saveItem">
                <i class="fas fa-save"></i>
            </button>
        </td>
        <td>
            <input class="input" v-model="name" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" v-model="color" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" v-model="displacement" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" type="number" @keyup="calculateTotal" v-model="result" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" type="number" @keyup="calculateTotal" v-model="commission" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" type="number" @keyup="calculateTotal" v-model="auction_fee" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" type="number" @keyup="calculateTotal" v-model="inland_transport" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" type="number" @keyup="calculateTotal" v-model="discount" :disabled="isLocked"/>
        </td>
        <td>
            <input class="input" type="number" v-model="total" :disabled="isLocked"/>
        </td>
        <td></td>
    </tr>
</template>

<script>
    export default {
        computed: {
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            },
            name: {
                get() {
                   return this.$store.getters.getProformaInvoiceNewSaleItem.name
                },
                set(value) {
                   this.$store.dispatch('changeProformaInvoiceNewSaleItemFieldValue', { field: 'name', value: value})
                }
            },
            color: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewSaleItem.color
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewSaleItemFieldValue', { field: 'color', value: value})
                }
            },
            displacement: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewSaleItem.displacement
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewSaleItemFieldValue', { field: 'displacement', value: value})
                }
            },
            result: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewSaleItem.result
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewSaleItemFieldValue', { field: 'result', value: value})
                }
            },
            commission: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewSaleItem.commission
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewSaleItemFieldValue', { field: 'commission', value: value})
                }
            },
            auction_fee: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewSaleItem.auction_fee
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewSaleItemFieldValue', { field: 'auction_fee', value: value})
                }
            },
            inland_transport: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewSaleItem.inland_transport
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewSaleItemFieldValue', { field: 'inland_transport', value: value})
                }
            },
            discount: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewSaleItem.discount
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewSaleItemFieldValue', { field: 'discount', value: value})
                }
            },
            total: {
                get() {
                    return this.$store.getters.getProformaInvoiceNewSaleItem.total
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceNewSaleItemFieldValue', { field: 'total', value: value})
                }
            }
        },
        methods: {
            calculateTotal() {
                this.total = Number(this.result) + Number(this.commission) + Number(this.auction_fee) + Number(this.inland_transport) - Number(this.discount)
            },
            saveItem() {
                this.$store.dispatch('saveProformaInvoiceSaleItem')
                this.$store.dispatch('changeProformaInvoiceTotalSaleAmount')
                this.$store.dispatch('calculateProformaInvoice')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceSalesTableCreateRow.vue